import React from "react";
import '../index.css';
import CanonicalTag from "./CanonicalTag";
import { Helmet } from "react-helmet";
import cementSeparator from '../assets/Images/cement-septor.jpg';
import cementSilo from '../assets/Images/cement silos 4.webp';
import rotaryCement from '../assets/Images/rotary-cement-packing.jpg';
import bagFilter from '../assets/Images/filter-bags-cages-fiberglass.jpg';

const CementEquipments = () => {
  return (
    <>
   <Helmet>
  <title>Cement Plant Equipment Manufacturer & Supplier | Valerion Impex</title>

  <meta
    name="description"
    content="Valerion Impex manufactures and supplies high-quality cement plant equipment including rotary kilns, crushers, ball mills, vertical roller mills, clinker coolers, conveyors and cement plant machinery for industrial applications."
  />

  <meta
    name="keywords"
    content="cement plant equipment, cement machinery, cement plant machinery, rotary kiln manufacturer, ball mill manufacturer, vertical roller mill, clinker cooler, cement crusher, cement conveyor, cement industry equipment, cement plant spare parts, industrial machinery, cement equipment supplier, cement plant manufacturer, Valerion Impex"
  />
</Helmet>

    <CanonicalTag url="https://www.cementmachineryparts.in/products/cement-equipments" />
    <div className="container">
      <h1 className="text-center bg-dark text-white mt-4 cement-raw p-2 d-flex justify-content-center mx-auto rounded">
        Cement Equipments & Storage
      </h1>

      {/* Cement Separator */}
      <div className="row align-items-center mt-4 mb-3">
        <div className="col-lg-6 mb-3">
          <img src={cementSeparator} alt="Cement Separator" className="img-fluid rounded" />
        </div>
        <div className="col-lg-6 fs-5">
          <h2 className="text-primary text-center">Cement Separator</h2>
          <p><b className="text-danger">Throughput:</b> 21–250 t/h</p>
          <p><b className="text-danger">Fan speed:</b> 900–1680 rpm</p>
          <p><b className="text-danger">Application:</b> Cement, Portland products, refractories, ceramics, etc.</p>
          <p>
            Cement separator is mainly used in the coal/raw/cement mill systems to improve efficiency and reduce energy use.
          </p>
          <p className="text-center fs-5 fw-bold mt-3">Highlights</p>
          <ul>
            <li>Over 80% powder selection efficiency</li>
            <li>Boosts output by 15–100%, reduces power use by 10–20%</li>
            <li>Improves particle size distribution and cement strength</li>
          </ul>
        </div>
      </div>

      {/* Cement Silo */}
      <div className="row align-items-center mt-2 mb-3 flex-lg-row-reverse">
        <div className="col-lg-6 mb-3">
          <img src={cementSilo} alt="Cement Silo" className="img-fluid rounded" />
        </div>
        <div className="col-lg-6 fs-5">
          <h2 className="text-primary text-center">Cement Silo</h2>
          <p><b className="text-danger">Production Capacity:</b> up to 100,000 tonnes</p>
          <p><b className="text-danger">Application:</b> clinker, finished cement, fly ash, etc.</p>
          <p>
            Cement silos store and distribute bulk cement. Available in various sizes (fixed or portable), they are used in all scales of cement plants and often include blowers for discharge.
          </p>
          <p className="text-center fs-5 fw-bold mt-3">Advantages</p>
          <ul>
            <li>Sizes up to 100,000 tonnes</li>
            <li>Includes blowers, collectors, and transfer pods</li>
            <li>Built with expert on-site supervision</li>
          </ul>
        </div>
      </div>

      {/* Cement Packing Machine */}
      <div className="row align-items-center mt-2 mb-3">
        <div className="col-lg-6 mb-3">
          <img src={rotaryCement} alt="Rotary Cement Packing Machine" className="img-fluid rounded" />
        </div>
        <div className="col-lg-6 fs-5">
          <h2 className="text-primary text-center">Cement Packing Machine</h2>
          <p>
            Cement packing machines are essential for automatic packing of cement and powder materials (fly ash, gypsum, etc.).
            Used in cement plants and construction material industries.
          </p>
        </div>
      </div>

      {/* Bag Filter */}
      <div className="row align-items-center mt-2 mb-3 flex-lg-row-reverse">
        <div className="col-lg-6 mb-3">
          <img src={bagFilter} alt="Bag Filter" className="img-fluid rounded" />
        </div>
        <div className="col-lg-6 fs-5">
          <h2 className="text-primary text-center">Bag Filter</h2>
          <p><b className="text-danger">Size:</b> 4x10, 7x16, 4x20, 7x32</p>
          <p><b className="text-danger">Application:</b> Cement, steel, and power industries</p>
          <p>
            Bag filters remove dust in exhaust gases. They work across various temperatures using appropriate filter media.
            They are more efficient than cyclones and can capture submicron particles.
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default CementEquipments;
